import type { RouteObject } from 'react-router';
import { handle } from '@/app/router/handle';

/** /dashboard */
export const dashboardRoutes: RouteObject = {
  path: 'dashboard',
  handle: handle('dashboard'),
  lazy: () => import('./DashboardPage').then((m) => ({ Component: m.DashboardPage })),
};
